var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PageLayout,{attrs:{"back-route":"/statistics/event-tracer/","title":`Событие ${_setup.eventID}`}},[_c(_setup.EventTraceCards,{attrs:{"cards":_setup.cards,"event":_setup.event,"is-loading":_setup.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }